import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  ClientBasicDetailsType,
  LeadInfoDetailsType,
  ProfileSetupDetailsType,
  RegistrationInputDetailsType,
  TaxAndBillingDetailsType,
} from "../../../commonTypes/clientDirectoryTypes";
import { UploadFileTypesPayload } from "../../../commonTypes/fileManagerTypes";
import { GetAllAssignUserOfSingleClient } from "../../../redux/auth/authTypes";
import ImageModal from "../../../screens/AdminReports/OpenItemsProgressReports/ImageModal";
import {
  formatDate,
  formateDateAndTime,
  isEmailValid,
} from "../../../utils/commonFunctions";
import { singleImagePreview } from "../../../utils/invoiceGeneration/commonFunctions";
import { SelctOptionType } from "../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import AssignedUsers from "./AssignedUsers";
import ClientBasicDetails from "./ClientBasicDetails";
import LeadInfoTab from "./LeadInfoTab";
import ProfileSetupTab from "./ProfileSetupTab";
import RegistrationsTab from "./RegistrationsTab";
import TaxAndBillingTab from "./TaxAndBillingTab";
import { ScopeOfWork } from "../../../screens";
import SubscriptionTab from "./SubscriptionTab";
type TabsType = {
  name: string;
  label: string;
};

export type InputDetailsErrorType = {
  entityError: string;
  firstNameError: string;
  companyNameError: string;
  countryError: string;
  cityError: string;
  stateError: string;
  mobileError: string;
  emailError: string;
  currencyError: string;
};
const tabs: TabsType[] = [
  {
    name: "Basic Details",
    label: "basicDetails",
  },
  {
    name: "Registrations",
    label: "registrations",
  },
  {
    name: "Profile Setup",
    label: "profileSetup",
  },
  {
    name: "Tax and Billing",
    label: "taxAndBilling",
  },
  {
    name: "Lead Info",
    label: "leadInfo",
  },
];

type AppProps = {
  history: any;
  clientAadharUniqueCheckFetching: boolean;
  userFetching?: boolean;
  clientPanUniqueCheckFetching: boolean;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  singleClientDirectory?: any;
  allAssignUserOfSingleClient?: GetAllAssignUserOfSingleClient | null;
  handleSubmit: (data: any) => void;
  handleAssignedUsersFilter?: (data: any) => void;
  dispatchResetClientAadharUniqueCheckMessage: () => void;
  dispatchResetClientPanUniqueCheckMessage: () => void;
  handleClientPanUniqueCheck: (data: any) => void;
  handleClientAadharUniqueCheck: (data: any) => void;
  isDisabled?: boolean;
  isViewClientPresent?: boolean;
  isCity?: null | boolean;
  isState?: null | boolean;
  handleUnassignUser?: (data: any) => void;
  authSuccess?: number | null;
};
const ClientDirectoryForm = ({
  history,
  clientAadharUniqueCheckFetching,
  userFetching,
  clientPanUniqueCheckFetching,
  handleSubmit,
  singleClientDirectory,
  handleClientPanUniqueCheck,
  handleClientAadharUniqueCheck,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  dispatchResetClientPanUniqueCheckMessage,
  dispatchResetClientAadharUniqueCheckMessage,
  allAssignUserOfSingleClient,
  handleAssignedUsersFilter,
  isDisabled,
  isViewClientPresent,
  isCity,
  isState,
  handleUnassignUser,
  authSuccess,
}: AppProps) => {
  const isEdit = singleClientDirectory ? true : false;
  const sortByCc = history?.location?.state?.sortByCc;
  const sortByName = history?.location?.state?.sortByName;
  const sortByCf = history?.location?.state?.sortByCf;
  const searchValue = history?.location?.state?.searchValue;
  const persistCategory = history?.location?.state?.selectedClientCategoryFilter
    ? history?.location?.state?.selectedClientCategoryFilter
    : [];
  const persistcategoryFilter = history?.location?.state?.clientCategoryFilter
    ? history?.location?.state?.clientCategoryFilter
    : [];
  const persistScope = history?.location?.state?.selectedScopeofWorkFilter
    ? history?.location?.state?.selectedScopeofWorkFilter
    : [];
  const persistScopeFilter = history?.location?.state?.scopeofWorkFilter
    ? history?.location?.state?.scopeofWorkFilter
    : [];
  const persistBranchFilter = history?.location?.state?.branchFilter;
  const persistContactTypeFilter = history?.location?.state?.contactTypeFilter;
  const persistSignUpSourceFilter =
    history?.location?.state?.signUpSourceFilter;
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const [clientBasicDetails, setClientBasicDetails] =
    useState<ClientBasicDetailsType>({
      basicDetails: {
        firstName: "",
        lastName: "",
        profilePic: null,
        code: "",
        name: "",
        entity: {
          value: "",
          label: "Select..",
        },
        contactType: {
          value: "",
          label: "Select..",
        },
        mailingName: "",
        salutation: "",
        clientCategory: [],
      },
      assignedTo: {
        partner: {
          value: null,
          label: "Select..",
        },
        manager: {
          value: null,
          label: "Select..",
        },
        seniorManager: {
          value: null,
          label: "Select..",
        },
        accountingInCharge: {
          value: null,
          label: "Select..",
        },
        taxInCharge: {
          value: null,
          label: "Select..",
        },
        auditInCharge: {
          value: null,
          label: "Select..",
        },
        hrInCharge: {
          value: null,
          label: "Select..",
        },
        branch: {
          value: null,
          label: "Select..",
        },
        currency: {
          value: null,
          label: "Select..",
        },
        clientGroup: {
          value: null,
          label: "Select..",
        },
      },
      communication: {
        workPhone: "",
        mobile: "",
        fax: "",
        homePhone: "",
        email: "",
      },
      onlinePresence: {
        skype: "",
        linkedIn: "",
        twitter: "",
        website: "",
      },
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        address: "",
        city: {
          value: "",
          label: "Select..",
        },
        state: {
          value: "",
          label: "Select..",
        },
        postalCode: "",
        country: {
          value: "",
          label: "Select..",
        },
      },
    });

  const [registrationsInputDetails, setRegistrationsInputDetails] =
    useState<RegistrationInputDetailsType>({
      registrationDetails: {
        corporateIdOfTheCompany: "",
        directorOfPartnerId: "",
        tan: "",
        pan: "",
        tin: "",
        serviceTaxNumber: "",
        panDetails: null,
        tanDetails: null,
      },
      gstDetails: {
        gstNumber: "",
        legalName: "",
        tradeName: "",
        registrationType: "",
        registrationDate: "",
        constitutionOfBusiness: "",
        companyStatus: "",
      },
      registerdUnder: {
        iecCode: "",
        msmeUdhyamRegistration: "",
        startupIndia: "",
        iacApplication: "",
        gumasta: "",
        trademark: "",
      },
      labourLaw: {
        professionalTaxEmployee: "",
        professionalTaxEmployer: "",
        epfo: "",
      },
      others: {
        blackListed: {
          value: "No",
          label: "No",
        },
        numberOfEmployees: "",
        turnoverInCrores: "",
        lie: "",
        lin: "",
        aadhaarNo: "",
        categoryOfClient: {
          value: "",
          label: "Select..",
        },
        businessNature: "",
      },
    });
  const [profileSetupDetails, setProfileSetupDetails] =
    useState<ProfileSetupDetailsType>({
      profileSetup: {
        taxYearEnd: {
          value: null,
          label: "Select..",
        },
        clientType: {
          value: "None",
          label: "None",
        },
        clientTypeSubcategory: {
          value: null,
          label: "Select..",
        },
        noOfEmployees: "",
        inBusinessSince: "",
      },
      annualAccountsMonth: {
        value: null,
        label: "Select..",
      },
      clientHistory: {
        clientFrom: null,
        clientUntil: null,
      },
    });

  const [taxAndBillingDetails, setTaxAndBillingDetails] =
    useState<TaxAndBillingDetailsType>({
      serviceDetails: {
        serviceTaxRegistered: {
          value: "No",
          label: "No",
        },
        serviceTaxPeriod: {
          value: "None",
          label: "None",
        },
        serviceTaxBasis: {
          value: "None",
          label: "None",
        },
        prepareServiceTax: {
          value: "No",
          label: "No",
        },
      },
      billingDetails: {
        billingEntity: {
          value: "No",
          label: "No",
        },
        chargeInterest: {
          value: "No",
          label: "No",
        },
        interestPeriod: {
          value: null,
          label: "Select..",
        },
        chargeMonthlyDisbursement: {
          value: "No",
          label: "No",
        },
        sendInvoiceReminder: {
          value: "No",
          label: "No",
        },
        interestRate: "",
        targetHours: "",
      },
    });

  const [selectedAccessTeam, setSelectedAccessTeam] = useState<number[] | []>(
    []
  );
  const [userSelected, setUserSelected] = useState<SelctOptionType[]>([]);
  const [selectedClientCategory, setSelectedClientCategory] = useState<
    number[] | []
  >([]);
  const [clientCategory, setClientCategory] = useState<SelctOptionType[]>([]);
  const [selectedScopeOfWork, setSelectedScopeOfWork] = useState<number[] | []>(
    []
  );
  const [scopeOfWork, setScopeOfWork] = useState<SelctOptionType[]>([]);
  let containerName: string | undefined =
    process.env.REACT_APP_USER_CONTAINER_NAME;
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);
  const [uploadData, setUploadData] = useState<any>([]);
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [modal, toggleModal] = useState<boolean>(false);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [leadInfoDetails, setLeadInfoDetails] = useState<LeadInfoDetailsType>({
    leadInfo: {
      leadReceivedOn: "",
      leadAssignedTo: {
        value: null,
        label: "Select..",
      },
      demoAssignedTo: {
        value: null,
        label: "Select..",
      },
      meetingAssignedTo: {
        value: null,
        label: "Select..",
      },
      accessTeamMembersId: [],
      meetingTimewithDate: "",
      followUpDateWithTime: "",
    },
    leadDetails: {
      response: "",
      source: "",
      feedback: "",
      uniqueId: null,
      stage: {
        value: null,
        label: "Select..",
      },
      callFrequency: {
        value: null,
        label: "Select..",
      },
      leadCategary: {
        value: null,
        label: "Select..",
      },
      status: true,
    },
    companyDetails: {
      companyName: "",
      contactPersonName: "",
      contactNumber: "",
      emailId: "",
      gstNumberRegister: false,
    },
    scopeOfWorkDetails: {
      scopeOfWork: [],
    },

    attachments: [],
  });

  const [inputDetailsError, setInputDetailsError] =
    useState<InputDetailsErrorType>({
      entityError: "",
      firstNameError: "",
      companyNameError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      mobileError: "",
      emailError: "",
      currencyError: "",
    });
  useEffect(() => {
    if (!isEdit) {
      if (
        clientBasicDetails?.basicDetails?.contactType?.value === "Lead" ||
        clientBasicDetails?.basicDetails?.contactType?.value ===
          "Lead & Supplier"
      ) {
        setLeadInfoDetails((prev: any) => {
          return {
            ...prev,
            leadDetails: {
              ...prev.leadDetails,
              stage: {
                value: "1a: New Lead",
                label: "1a: New Lead",
              },
              uniqueId: 2,
            },
          };
        });
      } else {
        setLeadInfoDetails((prev: any) => {
          return {
            ...prev,
            leadDetails: {
              ...prev.leadDetails,
              stage: {
                value: "",
                label: "Select..",
              },
            },
          };
        });
      }
    }
  }, [clientBasicDetails?.basicDetails?.contactType]);

  const showUploadModal = () => {
    toggleModal(!modal);
  };
  const handleUploadFile = (data: UploadFileTypesPayload) => {
    setImageDetails(data);
    setShowFileUploadModal(false);
    setUploadData((prevUploadData: any) => [...prevUploadData, data]);
  };

  useEffect(() => {
    if (showImagePreview && uploadData?.length) {
      getImageDetails({ ...uploadData[0] }, 0);
    }
  }, [showImagePreview, uploadData]);

  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(uploadData));
    const updatedFiles = [...uploadData];
    setUploadData(updatedFiles?.filter((e: any) => e?.file_url !== index));
  };
  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };
  const getImageDetails = (data: any, index: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const renderFilesList = () => {
    const isDelete = false;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        return singleImagePreview(
          data,
          index,
          getImageDetails,
          handleEditFileList,
          setShowPopUpContentModal,
          isDelete,
          uploadData
        );
      });
    return finalFileList;
  };

  useEffect(() => {
    if (isEdit && tabs?.length === 5) {
      tabs.push({
        name: "Assigned Users",
        label: "assignedUsers",
      });
    } else if (!isEdit) {
      if (tabs?.length === 6) {
        tabs.pop();
      }
    }
  }, [isEdit]);

  useEffect(() => {
    if (isDisabled && tabs?.length === 6 && isViewClientPresent) {
      tabs.pop();
      tabs.pop();
    }
  }, [isDisabled]);

  useEffect(() => {
    setLeadInfoDetails((prv: any) => {
      return {
        ...prv,
        leadInfo: {
          ...prv.leadInfo,
          accessTeamMembersId: selectedAccessTeam,
        },
      };
    });
  }, [selectedAccessTeam]);

  useEffect(() => {
    setClientBasicDetails((prv: any) => {
      return {
        ...prv,
        basicDetails: {
          ...prv.basicDetails,
          clientCategory: clientCategory,
        },
      };
    });
  }, [clientCategory]);

  useEffect(() => {
    setLeadInfoDetails((prv: any) => {
      return {
        ...prv,
        scopeOfWorkDetails: {
          ...prv.scopeOfWorkDetails,
          scopeOfWork: scopeOfWork,
        },
      };
    });
  }, [scopeOfWork]);

  useEffect(() => {
    if (
      leadInfoDetails?.attachments &&
      leadInfoDetails?.attachments?.length > 0
    ) {
      setUploadData([...leadInfoDetails?.attachments]);
    }
  }, [leadInfoDetails?.attachments, leadInfoDetails]);
  useEffect(() => {
    if (singleClientDirectory) {
      if (
        singleClientDirectory?.is_client_signup_created &&
        !tabs?.some((item) => item?.label === "subscription")
      ) {
        tabs?.push({
          name: "Subscription",
          label: "subscription",
        });
      } else if (tabs?.some((item) => item?.label === "subscription")) {
        tabs?.pop();
      }

      const basic = singleClientDirectory?.user_details?.basic_details;
      const postal =
        singleClientDirectory?.user_details?.postal_address_details;
      const communicationDetails =
        singleClientDirectory?.user_details?.contact_details;
      const online = singleClientDirectory?.user_details?.online_presence;
      const basicDetailsDropDownLabel =
        singleClientDirectory?.user_details?.assigned_to_details;
      const acountInChargeFirstAndLastName = `${
        basicDetailsDropDownLabel?.accounting_in_charge?.first_name
          ? basicDetailsDropDownLabel?.accounting_in_charge?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.accounting_in_charge?.last_name
          ? basicDetailsDropDownLabel?.accounting_in_charge?.last_name + " "
          : ""
      }`;
      const auditInChargeFirstAndLastName = `${
        basicDetailsDropDownLabel?.audit_in_charge?.first_name
          ? basicDetailsDropDownLabel?.audit_in_charge?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.audit_in_charge?.last_name
          ? basicDetailsDropDownLabel?.audit_in_charge?.last_name
          : ""
      }`;
      const hrInChargeFirstAndLastName = `${
        basicDetailsDropDownLabel?.hr_in_charge?.first_name
          ? basicDetailsDropDownLabel?.hr_in_charge?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.hr_in_charge?.last_name
          ? basicDetailsDropDownLabel?.hr_in_charge?.last_name + " "
          : ""
      }`;
      const managerFirstAndLastName = `${
        basicDetailsDropDownLabel?.manager?.first_name
          ? basicDetailsDropDownLabel?.manager?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.manager?.last_name
          ? basicDetailsDropDownLabel?.manager?.last_name + " "
          : ""
      }`;
      const seniorManagerFirstAndLastName = `${
        basicDetailsDropDownLabel?.senior_manager?.first_name
          ? basicDetailsDropDownLabel?.senior_manager?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.senior_manager?.last_name
          ? basicDetailsDropDownLabel?.senior_manager?.last_name + " "
          : ""
      }`;
      const partnerFirstAndLastName = `${
        basicDetailsDropDownLabel?.partner?.first_name
          ? basicDetailsDropDownLabel?.partner?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.partner?.last_name
          ? basicDetailsDropDownLabel?.partner?.last_name + " "
          : ""
      }`;
      const taxInChargeFirstAndLastName = `${
        basicDetailsDropDownLabel?.tax_in_charge?.first_name
          ? basicDetailsDropDownLabel?.tax_in_charge?.first_name + " "
          : ""
      }${
        basicDetailsDropDownLabel?.tax_in_charge?.last_name
          ? basicDetailsDropDownLabel?.tax_in_charge?.last_name + " "
          : ""
      }`;
      const leadInfo = singleClientDirectory?.lead_info_details;
      const leadInfoName = `${
        leadInfo?.lead_assigned_to?.first_name
          ? leadInfo?.lead_assigned_to?.first_name + " "
          : ""
      }${
        leadInfo?.lead_assigned_to?.last_name
          ? leadInfo?.lead_assigned_to?.last_name + " "
          : ""
      }`;
      const demoInfoName = `${
        leadInfo?.demo_assigned_to?.first_name
          ? leadInfo?.demo_assigned_to?.first_name + " "
          : ""
      }${
        leadInfo?.demo_assigned_to?.last_name
          ? leadInfo?.demo_assigned_to?.last_name + " "
          : ""
      }`;
      const meetingInfoName = `${
        leadInfo?.meeting_assigned_to?.first_name
          ? leadInfo?.meeting_assigned_to?.first_name + " "
          : ""
      }${
        leadInfo?.meeting_assigned_to?.last_name
          ? leadInfo?.meeting_assigned_to?.last_name + " "
          : ""
      }`;
      const accessMemberName = `${
        leadInfo?.access_member_ids?.first_name
          ? leadInfo?.access_member_ids?.first_name + " "
          : ""
      }${
        leadInfo?.access_member_ids?.last_name
          ? leadInfo?.access_member_ids?.last_name + " "
          : ""
      }`;
      const attachmentData =
        singleClientDirectory?.lead_info_details?.attachments;
      const service =
        singleClientDirectory?.tax_and_billing_details?.service_tax_details;
      const billing =
        singleClientDirectory?.tax_and_billing_details?.billing_details;
      const registrationDetails = singleClientDirectory?.registration_details;
      const accessTeamMember = leadInfo?.access_members?.map(
        (e: any) => e?.user_id
      );
      let totalUser = leadInfo?.access_members?.map((e: any) => {
        return {
          value: e?.user_id,
          label: `${e?.first_name} ${e?.last_name ? e?.last_name : ""}`,
        };
      });
      setUserSelected(totalUser);

      const clientCategoryData =
        singleClientDirectory?.user_details?.basic_details?.client_category;
      if (clientCategoryData && clientCategoryData.length > 0) {
        const clientCategoryOptions = clientCategoryData.map(
          (category: any) => ({
            value: category?._id,
            label: category?.name_of_category,
          })
        );
        setClientCategory(clientCategoryOptions);
      } else {
        setClientCategory([]);
      }
      const scopeOfWorkData =
        singleClientDirectory?.lead_info_details?.scope_of_work_details
          ?.scope_of_work;
      if (scopeOfWorkData && scopeOfWorkData.length > 0) {
        const scopeOfWorkOptions = scopeOfWorkData.map((scope: any) => ({
          value: scope?._id,
          label: scope?.scope_of_work_name,
        }));
        setScopeOfWork(scopeOfWorkOptions);
      } else {
        setScopeOfWork([]);
      }

      setClientBasicDetails((prev: ClientBasicDetailsType) => {
        return {
          ...prev,
          basicDetails: {
            profilePic: singleClientDirectory?.user_details?.profile_pic
              ? singleClientDirectory?.user_details?.profile_pic
              : null,
            firstName: basic?.first_name,
            lastName: basic?.last_name,
            name: basic?.name,
            code: singleClientDirectory?.code,
            entity: {
              value: basic?.entity,
              label: basic?.entity ? basic?.entity : "Select..",
            },
            contactType: {
              value: basic?.contact_type,
              label: basic?.contact_type ? basic?.contact_type : "Select..",
            },
            mailingName: basic?.mailing_name,
            salutation: basic?.salutation,
            clientCategory: clientCategory,
          },
          postalAddress: {
            addressLine1: postal?.address_line1,
            addressLine2: postal?.address_line2,
            address: postal?.address,
            // city: postal?.city,
            city: {
              value: postal?.city?.value,
              label: postal?.city ? postal?.city?.label : "Select..",
            },
            state: {
              value: postal?.state?.value,
              label: postal?.state ? postal?.state?.label : "Select..",
            },
            postalCode: postal?.pincode,
            country: {
              value: postal?.country?.value,
              label: postal?.country?.label,
            },
          },
          communication: {
            workPhone: communicationDetails?.work_phone,
            mobile: communicationDetails?.mobile,
            fax: communicationDetails?.fax,
            homePhone: communicationDetails?.home_phone,
            email: communicationDetails?.email,
          },
          onlinePresence: {
            skype: online?.skype,
            linkedIn: online?.linkedin,
            twitter: online?.twitter,
            website: online?.website,
          },
          assignedTo: {
            partner: {
              value: basicDetailsDropDownLabel?.partner?.user_id
                ? basicDetailsDropDownLabel?.partner?.user_id
                : null,
              label: partnerFirstAndLastName
                ? partnerFirstAndLastName
                : "Select..",
            },
            manager: {
              value: basicDetailsDropDownLabel?.manager?.user_id
                ? basicDetailsDropDownLabel?.manager?.user_id
                : null,
              label: managerFirstAndLastName
                ? managerFirstAndLastName
                : "Select..",
            },
            seniorManager: {
              value: basicDetailsDropDownLabel?.senior_manager?.user_id
                ? basicDetailsDropDownLabel?.senior_manager?.user_id
                : null,
              label: seniorManagerFirstAndLastName
                ? seniorManagerFirstAndLastName
                : "Select..",
            },
            accountingInCharge: {
              value: basicDetailsDropDownLabel?.accounting_in_charge?.user_id
                ? basicDetailsDropDownLabel?.accounting_in_charge?.user_id
                : null,
              label: acountInChargeFirstAndLastName
                ? acountInChargeFirstAndLastName
                : "Select..",
            },
            taxInCharge: {
              value: basicDetailsDropDownLabel?.tax_in_charge?.user_id
                ? basicDetailsDropDownLabel?.tax_in_charge?.user_id
                : null,
              label: taxInChargeFirstAndLastName
                ? taxInChargeFirstAndLastName
                : "Select..",
            },
            auditInCharge: {
              value: basicDetailsDropDownLabel?.audit_in_charge?.user_id
                ? basicDetailsDropDownLabel?.audit_in_charge?.user_id
                : null,
              label: auditInChargeFirstAndLastName
                ? auditInChargeFirstAndLastName
                : "Select..",
            },
            hrInCharge: {
              value: basicDetailsDropDownLabel?.hr_in_charge?.user_id
                ? basicDetailsDropDownLabel?.hr_in_charge?.user_id
                : null,
              label: hrInChargeFirstAndLastName
                ? hrInChargeFirstAndLastName
                : "Select..",
            },
            branch: {
              value: basicDetailsDropDownLabel?.branch?._id
                ? basicDetailsDropDownLabel?.branch?._id
                : null,
              label: basicDetailsDropDownLabel?.branch?.branch_name
                ? basicDetailsDropDownLabel?.branch?.branch_name
                : "Select..",
            },
            clientGroup: {
              value: basicDetailsDropDownLabel?.client_group?._id
                ? basicDetailsDropDownLabel?.client_group?._id
                : null,
              label: basicDetailsDropDownLabel?.client_group?.client_group_name
                ? basicDetailsDropDownLabel?.client_group?.client_group_name
                : "Select..",
            },
            currency: {
              value: basicDetailsDropDownLabel?.currency?._id
                ? basicDetailsDropDownLabel?.currency?._id
                : null,
              label: basicDetailsDropDownLabel?.currency?.currency_name
                ? basicDetailsDropDownLabel?.currency?.currency_name
                : "Select..",
              currencyDetails: {
                currencyName: basicDetailsDropDownLabel?.currency?.currency_name
                  ? basicDetailsDropDownLabel?.currency?.currency_name
                  : "",
                currencyShortForm: basicDetailsDropDownLabel?.currency
                  ?.currency_short_form
                  ? basicDetailsDropDownLabel?.currency?.currency_short_form
                  : "",
                currencySign: basicDetailsDropDownLabel?.currency?.currency_sign
                  ? basicDetailsDropDownLabel?.currency?.currency_sign
                  : "",
                currencyId: basicDetailsDropDownLabel?.currency?._id
                  ? basicDetailsDropDownLabel?.currency?._id
                  : "",
              },
            },
          },
        };
      });

      setRegistrationsInputDetails((prev: RegistrationInputDetailsType) => {
        return {
          ...prev,
          registrationDetails: {
            corporateIdOfTheCompany: registrationDetails?.corporate_id,
            directorOfPartnerId: registrationDetails?.director_of_partner_id,
            tan: registrationDetails?.tan,
            pan: registrationDetails?.pan,
            tin: registrationDetails?.tin,
            serviceTaxNumber: registrationDetails?.service_tax_number,
            tanDetails: registrationDetails?.tan_details,
            panDetails: registrationDetails?.pan_details,
          },
          gstDetails: {
            gstNumber: registrationDetails?.gst_number,
            legalName: registrationDetails?.legal_name,
            tradeName: registrationDetails?.trade_name,
            registrationType: registrationDetails?.registration_type,
            registrationDate: registrationDetails?.registration_date
              ? formatDate(registrationDetails?.registration_date)
              : null,
            constitutionOfBusiness:
              registrationDetails?.constituion_of_business,
            companyStatus: registrationDetails?.company_status,
          },
          registerdUnder: {
            iecCode: registrationDetails?.registered_under_details?.iec_code,
            msmeUdhyamRegistration:
              registrationDetails?.registered_under_details
                ?.msme_udhyam_registration,
            startupIndia:
              registrationDetails?.registered_under_details?.startupindia,
            iacApplication:
              registrationDetails?.registered_under_details?.iac_80_application,
            gumasta: registrationDetails?.registered_under_details?.gumasta,
            trademark: registrationDetails?.registered_under_details?.trademark,
          },
          labourLaw: {
            professionalTaxEmployee:
              registrationDetails?.labour_law_details
                ?.professional_tax_employee,
            professionalTaxEmployer:
              registrationDetails?.labour_law_details
                ?.professional_tax_employer,
            epfo: registrationDetails?.labour_law_details?.epfo,
          },
          others: {
            blackListed: {
              value:
                registrationDetails?.others_details?.black_listed === true
                  ? "Yes"
                  : "No",
              label:
                registrationDetails?.others_details?.black_listed === true
                  ? "Yes"
                  : "No",
            },
            numberOfEmployees:
              registrationDetails?.others_details?.no_of_employees,
            turnoverInCrores:
              registrationDetails?.others_details?.turnover_in_crores,
            lie: registrationDetails?.others_details?.lie,
            lin: registrationDetails?.others_details?.lin,
            aadhaarNo: registrationDetails?.others_details?.adhar_number,
            categoryOfClient: {
              value: registrationDetails?.others_details?.category_of_client,
              label: registrationDetails?.others_details?.category_of_client
                ? registrationDetails?.others_details?.category_of_client
                : "Select..",
            },
            businessNature:
              registrationDetails?.others_details?.business_nature,
          },
        };
      });

      setLeadInfoDetails((prev: any) => {
        return {
          ...prev,
          leadInfo: {
            leadReceivedOn: leadInfo?.lead_received_on,
            leadAssignedTo: {
              value: leadInfo?.lead_assigned_to?.user_id,
              label: leadInfoName ? leadInfoName : "Select..",
            },
            demoAssignedTo: {
              value: leadInfo?.demo_assigned_to?.user_id,
              label: demoInfoName ? demoInfoName : "Select..",
            },
            meetingAssignedTo: {
              value: leadInfo?.meeting_assigned_to?.user_id,
              label: meetingInfoName ? meetingInfoName : "Select..",
            },
            accessTeamMembersId: accessTeamMember,
            meetingTimewithDate: leadInfo?.meeting_time
              ? formateDateAndTime(leadInfo?.meeting_time)
              : null,
            followUpDateWithTime: leadInfo?.follow_up_date
              ? formateDateAndTime(leadInfo?.follow_up_date)
              : null,
          },
          leadDetails: {
            response: leadInfo?.lead_details?.response,
            source: leadInfo?.lead_details?.source,
            feedback: leadInfo?.lead_details?.feedback,
            stage: {
              value: leadInfo?.lead_details?.stage_id,
              label: leadInfo?.lead_details?.stage
                ? leadInfo?.lead_details?.stage
                : "Select..",
            },
            callFrequency: {
              value: leadInfo?.lead_details?.call_frequency,
              label: leadInfo?.lead_details?.call_frequency
                ? leadInfo?.lead_details?.call_frequency
                : "Select..",
            },
            uniqueId: leadInfo?.lead_details?.lead_stage_unique_id,
            leadCategary: {
              value: leadInfo?.lead_details?.lead_category,
              label: leadInfo?.lead_details?.lead_category
                ? leadInfo?.lead_details?.lead_category
                : "Select..",
            },
            status: singleClientDirectory?.lead_info_details?.status,
          },
          companyDetails: {
            companyName: leadInfo?.company_details?.company_name,
            contactPersonName: leadInfo?.company_details?.contact_person_name,
            contactNumber: leadInfo?.company_details?.contact_number,
            emailId: leadInfo?.company_details?.email,
            gstNumberRegister: leadInfo?.company_details?.gst_number_registered,
          },
          scopeOfWorkDetails: {
            scopeOfWork: scopeOfWork,
          },
        };
      });
      if (singleClientDirectory?.lead_info_details?.attachments) {
        setUploadData([...attachmentData]);
      }
      setTaxAndBillingDetails((prev: TaxAndBillingDetailsType) => {
        return {
          ...prev,
          serviceDetails: {
            serviceTaxRegistered: {
              value: service?.service_tax_registered === true ? "Yes" : "No",
              label: service?.service_tax_registered === true ? "Yes" : "No",
            },
            serviceTaxPeriod: {
              value: service?.service_tax_period,
              label: service?.service_tax_period
                ? service?.service_tax_period
                : "Select..",
            },
            serviceTaxBasis: {
              value: service?.service_tax_basis,
              label: service?.service_tax_basis
                ? service?.service_tax_basis
                : "Select..",
            },
            prepareServiceTax: {
              value: service?.prepare_service_tax === true ? "Yes" : "No",
              label: service?.prepare_service_tax === true ? "Yes" : "No",
            },
          },
          billingDetails: {
            billingEntity: {
              value: billing?.billing_entity === true ? "Yes" : "No",
              label: billing?.billing_entity === true ? "Yes" : "No",
            },
            chargeInterest: {
              value: billing?.charge_interest === true ? "Yes" : "No",
              label: billing?.charge_interest === true ? "Yes" : "No",
            },
            interestPeriod: {
              value: billing?.interest_period,
              label: billing?.interest_period
                ? billing?.interest_period
                : "Select..",
            },
            chargeMonthlyDisbursement: {
              value:
                billing?.charge_monthly_disbursement === true ? "Yes" : "No",
              label:
                billing?.charge_monthly_disbursement === true ? "Yes" : "No",
            },
            sendInvoiceReminder: {
              value: billing?.send_invoice_reminder === true ? "Yes" : "No",
              label: billing?.send_invoice_reminder === true ? "Yes" : "No",
            },
            interestRate: billing?.interest_rate,
            targetHours: billing?.target_hours,
          },
        };
      });
      setProfileSetupDetails((prev: ProfileSetupDetailsType) => {
        return {
          ...prev,
          profileSetup: {
            taxYearEnd: {
              value: singleClientDirectory?.profile_setup_details?.tax_year_end,
              label: singleClientDirectory?.profile_setup_details?.tax_year_end
                ? singleClientDirectory?.profile_setup_details?.tax_year_end
                : "Select..",
            },
            clientType: {
              value: singleClientDirectory?.profile_setup_details?.client_type,
              label: singleClientDirectory?.profile_setup_details?.client_type
                ? singleClientDirectory?.profile_setup_details?.client_type
                : "Select..",
            },
            clientTypeSubcategory: {
              value:
                singleClientDirectory?.profile_setup_details
                  ?.clinet_type_subcategory,
              label: singleClientDirectory?.profile_setup_details
                ?.clinet_type_subcategory
                ? singleClientDirectory?.profile_setup_details
                    ?.clinet_type_subcategory
                : "Select..",
            },
            noOfEmployees:
              singleClientDirectory?.profile_setup_details?.no_of_employees,
            inBusinessSince: singleClientDirectory?.profile_setup_details
              ?.in_business_since
              ? singleClientDirectory?.profile_setup_details?.in_business_since
              : null,
          },
          annualAccountsMonth: {
            value:
              singleClientDirectory?.profile_setup_details
                ?.annual_accounts_month,
            label: singleClientDirectory?.profile_setup_details
              ?.annual_accounts_month
              ? singleClientDirectory?.profile_setup_details
                  ?.annual_accounts_month
              : "Select..",
          },
          clientHistory: {
            clientFrom: singleClientDirectory?.profile_setup_details
              ?.client_history?.client_from
              ? singleClientDirectory?.profile_setup_details?.client_history
                  ?.client_from
              : null,
            clientUntil: singleClientDirectory?.profile_setup_details
              ?.client_history?.client_until
              ? singleClientDirectory?.profile_setup_details?.client_history
                  ?.client_until
              : null,
          },
        };
      });
    } else if (tabs?.some((item) => item?.label === "subscription")) {
      tabs?.pop();
    }
  }, [singleClientDirectory]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };

  const renderTabs = () => {
    const finalTab = tabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className="pointer ml-3"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };

  const emptyFun = () => {
    return;
  };

  const activeTabRender = () => {
    switch (activeTab) {
      case "basicDetails":
        return (
          <ClientBasicDetails
            clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
            clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
            clientBasicDetails={clientBasicDetails}
            singleClientDirectory={singleClientDirectory}
            setClientBasicDetails={setClientBasicDetails}
            handleClientDirectoryFormSubmit={handleClientDirectoryFormSubmit}
            handleGoBack={handleGoBack}
            inputDetailsError={inputDetailsError}
            setInputDetailsError={setInputDetailsError}
            isEdit={isEdit}
            isDisabled={isDisabled}
            isViewClientPresent={isViewClientPresent}
            clientCategory={clientCategory}
            setClientCategory={setClientCategory}
            setSelectedClientCategory={setSelectedClientCategory}
            selectedClientCategory={selectedClientCategory}
            scopeOfWork={scopeOfWork}
            setScopeOfWork={setScopeOfWork}
            selectedScopeOfWork={selectedScopeOfWork}
            setSelectedScopeOfWork={setSelectedScopeOfWork}
          />
        );
      case "registrations":
        return (
          <RegistrationsTab
            clientAadharUniqueCheckFetching={clientAadharUniqueCheckFetching}
            clientPanUniqueCheckFetching={clientPanUniqueCheckFetching}
            clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
            clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
            dispatchResetClientAadharUniqueCheckMessage={
              dispatchResetClientAadharUniqueCheckMessage
            }
            dispatchResetClientPanUniqueCheckMessage={
              dispatchResetClientPanUniqueCheckMessage
            }
            registrationsInputDetails={registrationsInputDetails}
            setRegistrationsInputDetails={setRegistrationsInputDetails}
            handleClientDirectoryFormSubmit={handleClientDirectoryFormSubmit}
            handleGoBack={handleGoBack}
            singleClientDirectory={singleClientDirectory}
            handleClientPanUniqueCheck={handleClientPanUniqueCheck}
            handleClientAadharUniqueCheck={handleClientAadharUniqueCheck}
            isDisabled={isDisabled}
            isViewClientPresent={isViewClientPresent}
          />
        );
      case "profileSetup":
        return (
          <ProfileSetupTab
            clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
            clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
            profileSetupDetails={profileSetupDetails}
            handleClientDirectoryFormSubmit={handleClientDirectoryFormSubmit}
            handleGoBack={handleGoBack}
            setProfileSetupDetails={setProfileSetupDetails}
            singleClientDirectory={singleClientDirectory}
            isDisabled={isDisabled}
            isViewClientPresent={isViewClientPresent}
          />
        );
      case "taxAndBilling":
        return (
          <TaxAndBillingTab
            clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
            clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
            taxAndBillingDetails={taxAndBillingDetails}
            handleClientDirectoryFormSubmit={handleClientDirectoryFormSubmit}
            handleGoBack={handleGoBack}
            setTaxAndBillingDetails={setTaxAndBillingDetails}
            singleClientDirectory={singleClientDirectory}
            isDisabled={isDisabled}
            isViewClientPresent={isViewClientPresent}
          />
        );
      case "leadInfo":
        return (
          <LeadInfoTab
            clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
            clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
            leadInfoDetails={leadInfoDetails}
            setLeadInfoDetails={setLeadInfoDetails}
            handleClientDirectoryFormSubmit={handleClientDirectoryFormSubmit}
            handleGoBack={handleGoBack}
            singleClientDirectory={singleClientDirectory}
            selectedAccessTeam={selectedAccessTeam}
            setSelectedAccessTeam={setSelectedAccessTeam}
            userSelected={userSelected}
            setUserSelected={setUserSelected}
            modal={modal}
            showUploadModal={showUploadModal}
            containerName={containerName}
            uploadSuccessArray={uploadSuccessArray}
            setUploadSuccessArray={setUploadSuccessArray}
            // handleUploadFile={handleUploadFile}
            uploadData={uploadData}
            setUploadData={setUploadData}
            setShowImagePreview={setShowImagePreview}
            scopeOfWork={scopeOfWork}
            setScopeOfWork={setScopeOfWork}
            selectedScopeOfWork={selectedScopeOfWork}
            setSelectedScopeOfWork={setSelectedScopeOfWork}

            // isDisabled={isDisabled}
          />
        );
      case "assignedUsers":
        return (
          <>
            {isEdit && (
              <AssignedUsers
                allAssignUserOfSingleClient={allAssignUserOfSingleClient}
                userFetching={userFetching}
                handleAssignedUsersFilter={
                  handleAssignedUsersFilter
                    ? handleAssignedUsersFilter
                    : emptyFun
                }
                handleUnassignUser={handleUnassignUser}
                authSuccess={authSuccess}
                // isDisabled={isDisabled}
              />
            )}
          </>
        );
      case "subscription":
        return (
          <SubscriptionTab
            authSuccess={authSuccess}
            userFetching={userFetching}
            singleClientDirectory={singleClientDirectory}
          />
        );
      default:
        return (
          <ClientBasicDetails
            clientAadharUniqueCheckMessage={clientAadharUniqueCheckMessage}
            clientPanUniqueCheckMessage={clientPanUniqueCheckMessage}
            singleClientDirectory={singleClientDirectory}
            clientBasicDetails={clientBasicDetails}
            setClientBasicDetails={setClientBasicDetails}
            handleClientDirectoryFormSubmit={handleClientDirectoryFormSubmit}
            handleGoBack={handleGoBack}
            inputDetailsError={inputDetailsError}
            setInputDetailsError={setInputDetailsError}
            isEdit={isEdit}
            isDisabled={isDisabled}
            clientCategory={clientCategory}
            setClientCategory={setClientCategory}
            setSelectedClientCategory={setSelectedClientCategory}
            selectedClientCategory={selectedClientCategory}
            scopeOfWork={scopeOfWork}
            setScopeOfWork={setScopeOfWork}
            selectedScopeOfWork={selectedScopeOfWork}
            setSelectedScopeOfWork={setSelectedScopeOfWork}
          />
        );
    }
  };

  const updatedClientBasicDetails = { ...clientBasicDetails };
  const updatedLeadInfoDetails = { ...leadInfoDetails };

  const handleClientDirectoryFormSubmit = () => {
    if (
      clientBasicDetails?.basicDetails?.entity?.value !== "Individual" &&
      clientBasicDetails?.basicDetails?.entity?.value !==
        "Sole Proprietorship" &&
      clientBasicDetails?.basicDetails?.entity?.value &&
      clientBasicDetails?.basicDetails?.name?.trim() &&
      ((isState &&
        clientBasicDetails?.postalAddress?.state?.value &&
        clientBasicDetails?.postalAddress?.country?.value &&
        clientBasicDetails?.postalAddress?.city?.value) ||
        (!isState && clientBasicDetails?.postalAddress?.country?.value) ||
        (isState &&
          clientBasicDetails?.postalAddress?.state?.value &&
          clientBasicDetails?.postalAddress?.country?.value &&
          !isCity)) &&
      clientBasicDetails?.assignedTo?.currency?.value &&
      isEmailValid(clientBasicDetails?.communication?.email?.trim()) &&
      clientBasicDetails?.communication?.mobile?.trim()
    ) {
      if (
        !clientPanUniqueCheckMessage?.includes("PAN number already exists") &&
        !clientAadharUniqueCheckMessage?.includes(
          "Aadhaar number already exists"
        )
      ) {
        if (
          updatedClientBasicDetails.basicDetails &&
          updatedClientBasicDetails.basicDetails.clientCategory
        ) {
          updatedClientBasicDetails.basicDetails.clientCategory.forEach(
            (category: any) => {
              if (
                category.hasOwnProperty("value") &&
                category.hasOwnProperty("label")
              ) {
                category._id = category.value;
                category.name_of_category = category.label;

                delete category.value;
                delete category.label;
              }
            }
          );
        }

        if (
          updatedLeadInfoDetails &&
          updatedLeadInfoDetails?.scopeOfWorkDetails &&
          updatedLeadInfoDetails?.scopeOfWorkDetails?.scopeOfWork
        ) {
          updatedLeadInfoDetails?.scopeOfWorkDetails?.scopeOfWork?.forEach(
            (scope: any) => {
              if (
                scope?.hasOwnProperty("value") &&
                scope?.hasOwnProperty("label")
              ) {
                scope._id = scope?.value;
                scope.scope_of_work_name = scope?.label;

                delete scope?.value;
                delete scope?.label;
              }
            }
          );
        }
        const clientBasicDetails = {
          ...updatedClientBasicDetails,
        };
        const leadInfoDetails = {
          ...updatedLeadInfoDetails,
        };
        Object.keys(leadInfoDetails).forEach((key) => {
          leadInfoDetails["attachments"] = uploadData;
        });
        const finalData = {
          clientBasicDetails,
          // updatedClientBasicDetails,
          registrationsInputDetails,
          profileSetupDetails,
          taxAndBillingDetails,
          leadInfoDetails,
        };

        if (isEdit) {
          handleSubmit?.(finalData);
        } else {
          handleSubmit?.(finalData);
        }
      }
      //  else {
      //   toast.error('PAN And Aadhaar Number Should be Unique!', {
      //     duration: 3000
      //   });
      // }
    } else if (
      (clientBasicDetails?.basicDetails?.entity?.value === "Individual" ||
        clientBasicDetails?.basicDetails?.entity?.value ===
          "Sole Proprietorship" ||
        clientBasicDetails?.basicDetails?.entity?.value === "") &&
      clientBasicDetails?.basicDetails?.entity?.value &&
      clientBasicDetails?.basicDetails?.firstName?.trim() &&
      clientBasicDetails?.assignedTo?.currency?.value &&
      isEmailValid(clientBasicDetails?.communication?.email?.trim()) &&
      clientBasicDetails?.communication?.mobile?.trim() &&
      ((isState &&
        clientBasicDetails?.postalAddress?.state?.value &&
        clientBasicDetails?.postalAddress?.country?.value &&
        clientBasicDetails?.postalAddress?.city?.value) ||
        (!isState && clientBasicDetails?.postalAddress?.country?.value) ||
        (isState &&
          clientBasicDetails?.postalAddress?.state?.value &&
          clientBasicDetails?.postalAddress?.country?.value &&
          !isCity))
    ) {
      if (
        !clientPanUniqueCheckMessage?.includes("PAN number already exists") &&
        !clientAadharUniqueCheckMessage?.includes(
          "Aadhaar number already exists"
        )
      ) {
        if (
          updatedClientBasicDetails.basicDetails &&
          updatedClientBasicDetails.basicDetails.clientCategory
        ) {
          updatedClientBasicDetails.basicDetails.clientCategory.forEach(
            (category: any) => {
              if (
                category.hasOwnProperty("value") &&
                category.hasOwnProperty("label")
              ) {
                category._id = category.value;
                category.name_of_category = category.label;

                delete category.value;
                delete category.label;
              }
            }
          );
        }
        if (
          updatedLeadInfoDetails &&
          updatedLeadInfoDetails.scopeOfWorkDetails &&
          updatedLeadInfoDetails.scopeOfWorkDetails.scopeOfWork
        ) {
          updatedLeadInfoDetails.scopeOfWorkDetails.scopeOfWork.forEach(
            (scope: any) => {
              if (
                scope.hasOwnProperty("value") &&
                scope.hasOwnProperty("label")
              ) {
                scope._id = scope.value;
                scope.scope_of_work_name = scope.label;

                delete scope.value;
                delete scope.label;
              }
            }
          );
        }
        const leadInfoDetails = {
          ...updatedLeadInfoDetails,
        };
        const clientBasicDetails = {
          ...updatedClientBasicDetails,
        };
        Object.keys(leadInfoDetails).forEach((key) => {
          leadInfoDetails["attachments"] = uploadData;
        });
        const finalData = {
          clientBasicDetails,
          registrationsInputDetails,
          profileSetupDetails,
          taxAndBillingDetails,
          leadInfoDetails,
        };
        if (isEdit) {
          handleSubmit?.(finalData);
        } else {
          handleSubmit?.(finalData);
        }
      }
      // else {
      //   toast.error('PAN And Aadhaar Number Should be Unique!', {
      //     duration: 3000
      //   });
      // }
    } else {
      toast.error("Please Fill Required Field!", {
        duration: 2000,
      });
      setInputDetailsError((prev: any) => {
        return {
          ...prev,
          ...(!clientBasicDetails?.basicDetails?.entity?.value && {
            entityError: "Entity Required",
          }),
          ...(!clientBasicDetails?.basicDetails?.firstName?.trim() && {
            firstNameError: "First Name Required",
          }),
          ...(!clientBasicDetails?.basicDetails?.name && {
            companyNameError: "Name Required",
          }),
          ...(!clientBasicDetails?.postalAddress?.country?.value && {
            countryError: "Country Required",
          }),
          ...(!clientBasicDetails?.postalAddress?.state?.value && {
            stateError: "please select state",
          }),
          ...(!clientBasicDetails?.postalAddress?.city?.value && {
            cityError: "please select city",
          }),
          ...(!clientBasicDetails?.assignedTo?.currency?.value && {
            currencyError: "Currency Required",
          }),
          ...(!clientBasicDetails?.communication?.mobile?.trim() && {
            mobileError: "Mobile Required",
          }),
          ...(!clientBasicDetails?.communication?.email?.trim() && {
            emailError: "Email Required",
          }),
          ...(clientBasicDetails?.communication?.email?.length > 0 &&
            !isEmailValid(clientBasicDetails?.communication?.email) && {
              emailError: "Email not valid",
            }),
        };
      });
    }
  };

  const handleGoBack = () => {
    if (isViewClientPresent) {
      history?.push({
        pathname: "/assigned-client-directory",
        state: {
          sortByCc,
          sortByCf,
          sortByName,
          searchValue,
          persistCategory,
          persistcategoryFilter,
          persistScope,
          persistScopeFilter,
          persistBranchFilter,
          persistContactTypeFilter,
          persistSignUpSourceFilter,
        },
      });
    } else {
      history?.push({
        pathname: "/client-directory-list",
        state: {
          sortByCc,
          sortByCf,
          sortByName,
          searchValue,
          persistCategory,
          persistcategoryFilter,
          persistScope,
          persistScopeFilter,
          persistBranchFilter,
          persistContactTypeFilter,
          persistSignUpSourceFilter,
        },
      });
    }
  };

  return (
    <>
      <div className="col-md-12">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px 0px 0px",
          }}
        >
          <div className="d-flex align-items-center col-md-10">
            {renderTabs()}
          </div>
        </div>
        {activeTabRender()}
      </div>
      {showImagePreview && (
        <ImageModal
          showImagePreview={showImagePreview}
          setShowImagePreview={setShowImagePreview}
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
          renderFilesList={renderFilesList}
          uploadData={uploadData}
          setUploadData={setUploadData}
          type={"jobDetails"}
          handleEditFileList={handleEditFileList}
          isDelete={true}
        />
      )}
    </>
  );
};

export default ClientDirectoryForm;
